import React from 'react';
import { Sidebar, Element, Button } from '@quotient/riq-react-ui';
import { ShoppingList } from '@quotient/riq-shoppinglist';

const ShoppingListComp = ({ data }) => {
  const [isSidebarOpen, setSidebar] = React.useState(false);
  const toggleSidebar = () => setSidebar(!isSidebarOpen);

  return (
    <ShoppingList data={data}>
      <ShoppingList.CartCounter
        colors={{ bgActive: 'primary', bgInactive: 'grays.500', textColorActive: 'white' }}
        css={{ marginLeft: '10px' }}
        onClick={toggleSidebar}
      />
      <Sidebar width="400px" isOpen={isSidebarOpen} onDismiss={toggleSidebar} aria-labelledby="My Shopping List">
        <Sidebar.CloseDialog onDismiss={toggleSidebar} />
        <ShoppingList.Header />
        <ShoppingList.Body slButtonVariant="primary_noeffect">
          <ShoppingList.AddItemForm
            size="large"
            AddOnButton={
              <Button
                type="submit"
                variant="primary"
                size="large"
                css={{ width: '48px', fontSize: '32px', borderRadius: 'none' }}
              >
                +
              </Button>
            }
          />
          <Element as="hr" css={{ margin: 0, height: 2, background: 'secondary', width: '100%' }} />
        </ShoppingList.Body>
        <ShoppingList.Footer
          colors={{
            bgActive: 'primary',
            bgInactive: 'grays.600',
            textColorActive: 'white',
            textColorInActive: 'white'
          }}
        />
      </Sidebar>
    </ShoppingList>
  );
};

export { ShoppingListComp };
